<template>
  <router-view />
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || "Borrower Application";
      },
    },
  },
});
</script>
<style lang="scss">
@import "../src/styles/fonts.scss";
@import "../src/styles/site.scss";
@import "../src/styles/feedback.scss";
@import "../src/styles/refi.scss";
</style>
